import React from 'react';
import logo from '../../_assets/img/logo.svg';

/**
 * StickerBar — barre d'étiquette colorée réutilisable.
 *
 * Props :
 *   stickerLabel  string   Libellé affiché dans la barre
 *   stickerType   string   Variante couleur : 'noir' | 'rouge' | 'vert' | 'verte'
 */
function StickerBar({ stickerLabel, stickerType }) {
    if (!stickerLabel) return null;

    return (
        <div className={`sticker-bar sticker-bar--${stickerType}`}>
            <img src={logo} alt="GRDF" className="sticker-bar-logo" />
            {stickerLabel}
        </div>
    );
}

export { StickerBar };
